// XÁC MINH SAU KHI ĐĂNG (lỗi thật 03/10, YouTube, plugin 0.1.42, kịch bản Boss 40wczdl1ez): bước dang_binh_luan báo "đạt" — hậu kiểm thấy chữ bình
// luận NGOÀI ô soạn ngay sau khi bấm Bình luận — nhưng đọc lại video ("Hàng đầu" lẫn "Mới nhất") và trang lịch sử bình luận 30 phút sau thì KHÔNG
// có bình luận: YouTube nhận ở phía trình duyệt (vẽ ngay dưới video) rồi không lưu / ẩn (chống spam). Bot báo thành công giả.
// Cách làm (chỉ chạy THẬT, chỉ ĐỌC — không thao tác ghi nào thêm): bước gửi đạt → chờ một khoảng như người (Cài đặt xacMinhSauDangGiay, mặc định
// 20–40 s) → MỞ LẠI địa chỉ đích (tải lại trang) → cuộn tới khu bình luận → tìm bình luận có chữ vừa gửi (chuẩn hoá khoảng trắng / emoji).
//   thấy        → bước "đạt", ghi DANH_DAU_DA_XAC_MINH.
//   không thấy  → KHÔNG gửi lại (tránh trùng); dòng bước = "skip" + DANH_DAU_KHONG_THAY → không tính là đăng thành công (Việc đã làm, "N đạt",
//                 L-38), cảnh báo lần chạy (canhBaoKhongThaySauDang); sổ cái GIỮ (đã ghi trước đó) → lần sau không làm lại mục này.
//   không đọc được khu bình luận (trang không tải phần bình luận, câu chỉ có emoji…) → "chưa xác minh được" — giữ kết quả cũ, ghi rõ lý do.
// Nền tảng: chỉ những nơi có selector ĐÃ ĐO THẬT (xem chú thích đầu src/shared/yt-khoi.ts). Nền tảng khác → null (không xác minh, như trước).
import type { Locator } from "./bundle";

export const DANH_DAU_DA_XAC_MINH = "ĐÃ XÁC MINH sau khi tải lại";
export const DANH_DAU_KHONG_THAY = "ĐÃ GỬI nhưng sau khi tải lại KHÔNG THẤY";
export const DANH_DAU_CHUA_XAC_MINH = "chưa xác minh được sau khi tải lại";
export const MAC_DINH_CHO_GIAY: [number, number] = [20, 40];
// Số lượt (cuộn → chờ → đọc) sau khi tải lại; mỗi lượt chờ CHO_MOI_LUOT_MS. Bình luận YouTube chỉ tải sau cú lăn chuột THẬT.
export const SO_LUOT_DOC = 6;
export const CHO_MOI_LUOT_MS = 1500;

/** Selector content dùng để đọc khu bình luận (chỉ đọc). */
export interface CachTimChu {
  daTai: string; // có phần tử này đang hiện = khu bình luận ĐÃ tải (kể cả khi chưa có bình luận nào)
  muc: string; // mỗi bình luận
  chu: string; // chữ của bình luận (trong mục)
  tacGia?: string; // tên/@handle người viết (trong mục) — chỉ để ghi vào nhật ký
}
export interface CauHinhXacMinh {
  nenTang: "youtube" | "facebook";
  khu: Locator; // cuộn tới đây trước khi lăn
  lanThat: boolean; // khu bình luận chỉ tải sau cú lăn chuột thật (chrome.debugger)
  tim: CachTimChu;
}
/** khacNick: số bình luận mang ĐÚNG chữ nhưng người viết KHÔNG phải nick đang đăng nhập (chỉ có khi runner truyền nick) — không tính là "thấy". */
export interface KetQuaTimChu { daTai: boolean; soMuc: number; thay: boolean; tacGia?: string; khacNick?: number }
export type KqXacMinhDang = "da_xac_minh" | "khong_thay" | "chua_xac_minh";

// YouTube trang xem video (/watch?v=…) — selector ĐO THẬT 2026-09-21 23:50 (chú thích đầu yt-khoi.ts): bình luận chỉ tải khi cuộn tới #comments
// bằng lăn chuột thật; ô nhập #placeholder-area trong <ytd-comment-simplebox-renderer>; mỗi bình luận cấp 1 = <ytd-comment-thread-renderer> có
// #author-text (@handle) và #content-text; video tắt bình luận: #comments có <ytd-message-renderer>.
// CHƯA ĐO THẬT (không dùng): menu sắp xếp "Hàng đầu / Mới nhất" (YouTube cho người viết thấy bình luận của mình ở đầu danh sách mặc định — điều này
// cũng chưa đo thật, nên máy đọc thêm SO_LUOT_DOC lượt cuộn); luồng phản hồi thu gọn ("N phản hồi") — nên KHÔNG xác minh bước trả lời bình luận.
const YT: CauHinhXacMinh = {
  nenTang: "youtube",
  khu: { describe: "khu bình luận dưới video", ladder: [{ t: "css", sel: "#comments" }, { t: "css", sel: "ytd-comments" }] },
  lanThat: true,
  tim: {
    daTai: "ytd-comment-simplebox-renderer #placeholder-area, ytd-comment-thread-renderer, #comments ytd-message-renderer",
    muc: "ytd-comment-thread-renderer",
    chu: "#content-text",
    tacGia: "#author-text",
  },
};

const RE_TRA_LOI = /tra_loi|traloi|phan_hoi|reply|\brep\b/i;

/**
 * Cấu hình xác minh cho địa chỉ trang lúc vừa gửi + bước gửi. null = không xác minh (nền tảng chưa đo thật / loại việc chưa hỗ trợ).
 * Chỉ YouTube /watch?v=…, bước BÌNH LUẬN cấp 1 (không phải trả lời bình luận: phản hồi nằm trong luồng thu gọn — chưa đo thật cách mở).
 */
export function cauHinhXacMinhSauDang(url: string | null | undefined, step?: { id?: string; do?: string }): CauHinhXacMinh | null {
  let u: URL;
  try { u = new URL(String(url ?? "")); } catch { return null; }
  if (!/^https?:$/.test(u.protocol)) return null;
  if (step && (RE_TRA_LOI.test(step.id ?? "") || /\bph[aả]n h[oồ]i\b|\btr[aả] l[oờ]i\b/i.test(step.do ?? ""))) return null;
  const host = u.hostname.toLowerCase();
  if ((host === "youtube.com" || host.endsWith(".youtube.com")) && u.pathname === "/watch" && u.searchParams.get("v")) return YT;
  return null;
}

/**
 * Trang /…/watch?v=… KHÔNG ở youtube.com (trang giả của bộ E2E, bản gương): chỉ là ỨNG VIÊN — runner phải thấy phần tử nhận diện trang xem YouTube
 * đã ĐO THẬT (ytd-watch-metadata — chú thích "Đo thật Edge #2 2026-10-01" trong yt-khoi.ts) trên trang mới xác minh. youtube.com (đã nhận theo
 * địa chỉ ở cauHinhXacMinhSauDang) → null.
 */
export function ungVienXacMinhTheoDom(url: string | null | undefined, step?: { id?: string; do?: string }): { cauHinh: CauHinhXacMinh; nhanDien: string } | null {
  let u: URL;
  try { u = new URL(String(url ?? "")); } catch { return null; }
  if (!/^https?:$/.test(u.protocol) || cauHinhXacMinhSauDang(url)) return null;
  if (!/\/watch$/.test(u.pathname) || !u.searchParams.get("v")) return null;
  if (!cauHinhXacMinhSauDang(`https://www.youtube.com/watch?v=${encodeURIComponent(u.searchParams.get("v")!)}`, step)) return null; // bước trả lời → không
  return { cauHinh: YT, nhanDien: "ytd-watch-metadata" };
}

// ---------------------------------------------------------------------------------------------------------------------------------------------
// F-3 (06/10/2026, chuỗi 6 giờ Bot Egh, plugin 0.1.56): bước gửi bình luận FACEBOOK thất bại ở tình huống MƠ HỒ — AI chẩn đoán "đã đặt theo cách khác"
// (thấy 'Đã gửi bình luận của bạn') hoặc đã gõ + Enter mà hậu kiểm không thấy chữ — trước đây: bỏ mục + KHÔNG ghi sổ → vòng sau bình luận TRÙNG bài.
// Nay runner ĐỌC LẠI bình luận của nick trên bài (CHỈ ĐỌC, không gửi lại): thấy → tính đã xong + ghi sổ; không thấy → ghi sổ "có thể đã đăng — cần xác nhận".
// Khác YouTube ở trên: KHÔNG chạy sau mỗi lần đăng thành công (XM6 giữ nguyên: Facebook không xác minh sau đăng thành công) — chỉ chạy ở đường thất bại mơ hồ.
// Selector CHƯA ĐO THẬT riêng cho việc đọc (cấu trúc bình luận Facebook: div[role=article] — cùng gốc với xpath hậu kiểm ảnh FB_HAU_KIEM_ANH đã dùng thật 04/10);
// chữ so trong MỌI div/span của article (bỏ ô soạn contenteditable) nên không phụ thuộc lớp CSS ngẫu nhiên của Facebook. Đo lại trên Facebook thật.
// ---------------------------------------------------------------------------------------------------------------------------------------------
export const DANH_DAU_XAC_MINH_FB = "ĐÃ XÁC MINH bình luận có trên trang";
export const DANH_DAU_CO_THE_DA_DANG = "CÓ THỂ ĐÃ ĐĂNG — cần xác nhận";

const FB_DOC: CauHinhXacMinh = {
  nenTang: "facebook",
  khu: { describe: "khu bình luận của bài", ladder: [{ t: "css", sel: 'div[role="article"]' }] },
  lanThat: false,
  tim: {
    daTai: 'div[role="article"], div[role="textbox"][contenteditable="true"]',
    muc: 'div[role="article"]',
    chu: "div, span",
    tacGia: 'a[role="link"], a[href]',
  },
};

/** Cấu hình ĐỌC LẠI bình luận trên Facebook (www / m / mbasic / web / fb.com). Địa chỉ khác / hỏng → null. */
export function cauHinhXacMinhFacebook(url: string | null | undefined): CauHinhXacMinh | null {
  let u: URL;
  try { u = new URL(String(url ?? "")); } catch { return null; }
  if (!/^https?:$/.test(u.protocol)) return null;
  return /^(?:(?:www|m|mbasic|web)\.)?(?:facebook\.com|fb\.com)$/i.test(u.hostname) ? FB_DOC : null;
}

/** Trang giả của bộ E2E / bản gương Facebook ở tên máy KHÁC facebook.com: chỉ là ỨNG VIÊN — runner phải thấy phần tử nhận diện bài Facebook (thuộc tính thật story_message) trên trang. */
export const NHAN_DIEN_FB_DOM = '[data-ad-rendering-role="story_message"], [data-ad-comet-preview="message"]';
export function cauHinhXacMinhFacebookTheoDom(): CauHinhXacMinh { return FB_DOC; }
/** Địa chỉ http(s) hợp lệ (để xét ứng viên theo DOM). */
export function laDiaChiHttp(url: string | null | undefined): boolean {
  try { return /^https?:$/.test(new URL(String(url ?? "")).protocol); } catch { return false; }
}

/** Tải lại địa chỉ này có ra lại CHÍNH bài (để đọc bình luận) không: trang bài (posts / permalink / photo / video / reel / story.php / multi_permalinks). Kết quả tìm kiếm, bảng tin, trang nhóm trơn → không. */
export function trangBaiTaiLaiDuoc(url: string | null | undefined): boolean {
  let u: URL;
  try { u = new URL(String(url ?? "")); } catch { return false; }
  if (!/^https?:$/.test(u.protocol)) return false; // (tên máy nào cũng được: đã xác định là trang Facebook ở nơi gọi — kể cả trang giả của bộ E2E)
  const p = u.pathname.toLowerCase();
  if (/\/(?:posts|permalink|videos|reel|reels|watch)\/[^/]+/.test(p)) return true;
  if (/\/photo(?:\.php)?\/?$/.test(p) && (u.searchParams.get("fbid") ?? "") !== "") return true;
  if (/^\/(?:story|permalink)\.php$/.test(p) && (u.searchParams.get("story_fbid") ?? "") !== "") return true;
  if (u.searchParams.get("multi_permalinks")) return true;
  return false;
}

/** Dòng CHÍNH của bước gửi: có thể ĐÃ đăng nhưng máy không xác minh được (đã ghi sổ để không đăng lại). */
export function laDongCoTheDaDang(l: { key?: string; status?: string; reason?: string }): boolean {
  return !(l.key ?? "").includes("~") && (l.reason ?? "").includes(DANH_DAU_CO_THE_DA_DANG);
}
/** Dòng CHÍNH của bước gửi đã được xác minh ở đường thất bại mơ hồ (đọc lại thấy bình luận của nick). */
export function laDongXacMinhFb(l: { key?: string; status?: string; reason?: string }): boolean {
  return l.status === "ok" && !(l.key ?? "").includes("~") && (l.reason ?? "").includes(DANH_DAU_XAC_MINH_FB);
}

/** Khoảng chờ trước khi tải lại (giây) từ Cài đặt; không đặt → mặc định 20–40. [0, 0] (hoặc số hỏng ≤ 0) = TẮT. */
export function khoangChoXacMinh(cai: [number, number] | null | undefined): [number, number] {
  if (!Array.isArray(cai)) return MAC_DINH_CHO_GIAY;
  const lo = Math.max(0, Number.isFinite(Number(cai[0])) ? Number(cai[0]) : 0);
  const hi = Math.max(lo, Number.isFinite(Number(cai[1])) ? Number(cai[1]) : 0);
  return [lo, hi];
}

// Chuẩn hoá để so: NFC (chữ Việt dựng sẵn / tổ hợp như nhau), bỏ emoji (trang vẽ emoji thành <img> — không còn trong chữ), gộp khoảng trắng, chữ thường.
const EMOJI = /[\p{Extended_Pictographic}\p{Emoji_Presentation}️‍⃣]/gu;
export function chuanHoaChu(s: string | null | undefined): string {
  return String(s ?? "").normalize("NFC").replace(EMOJI, "").replace(/\s+/g, " ").trim().toLowerCase();
}
/** Câu đã gửi còn chữ để so không (câu chỉ có emoji / khoảng trắng → không so được). */
export const coTheSoChu = (daGui: string | null | undefined): boolean => chuanHoaChu(daGui).length > 0;

const DAU_TOI_DA = 80;
/**
 * Chữ đang hiện của một bình luận có phải câu vừa gửi không. Nguyên câu (đã chuẩn hoá) nằm trong chữ hiện; câu dài thì đủ 80 ký tự đầu
 * (cắt ở ranh giới từ — trang có thể rút gọn "… Đọc thêm"). Câu rỗng sau chuẩn hoá → false (không bao giờ khớp mọi bình luận).
 */
export function khopChuDaGui(daGui: string | null | undefined, hienThi: string | null | undefined): boolean {
  const a = chuanHoaChu(daGui), b = chuanHoaChu(hienThi);
  if (!a || !b) return false;
  if (b.includes(a)) return true;
  if (a.length <= DAU_TOI_DA) return false;
  const c = a.slice(0, DAU_TOI_DA), sp = c.lastIndexOf(" ");
  const dau = (sp >= 40 ? c.slice(0, sp) : c).trim();
  return dau.length >= 40 && b.includes(dau);
}

export interface DongLite { key?: string; stepId: string; kind?: string; status: string; reason?: string; item?: string }
/** Dòng CHÍNH của bước gửi đã gửi nhưng sau khi tải lại không thấy (không tính là việc đã làm). */
export function laDongKhongThaySauDang(l: { key?: string; kind?: string; status: string; reason?: string }): boolean {
  return l.status === "skip" && !(l.key ?? "").includes("~") && (l.reason ?? "").startsWith(DANH_DAU_KHONG_THAY);
}
export function laDongDaXacMinh(l: { key?: string; status: string; reason?: string }): boolean {
  return l.status === "ok" && !(l.key ?? "").includes("~") && (l.reason ?? "").includes(DANH_DAU_DA_XAC_MINH);
}

/** Cảnh báo lần chạy: các bước gửi "đã gửi nhưng tải lại không thấy" (null = không có). */
export function canhBaoKhongThaySauDang(logs: DongLite[] | null | undefined): string | null {
  const ds = (logs ?? []).filter(laDongKhongThaySauDang);
  if (!ds.length) return null;
  const buoc = [...new Set(ds.map((l) => l.stepId))].join(", ");
  return `${ds.length} việc đã gửi nhưng sau khi tải lại KHÔNG THẤY (bước ${buoc}) — mạng xã hội có thể đã ẩn/giữ lại bình luận; KHÔNG tính là đăng thành công, máy không gửi lại (tránh trùng). Hãy mở trang kiểm tra bằng mắt; nick có thể đang bị hạn chế.`;
}

/** Cảnh báo lần chạy (F-3): các bình luận CÓ THỂ ĐÃ ĐĂNG nhưng máy không xác minh được (null = không có). */
export function canhBaoCoTheDaDang(logs: DongLite[] | null | undefined): string | null {
  const ds = (logs ?? []).filter(laDongCoTheDaDang);
  if (!ds.length) return null;
  const buoc = [...new Set(ds.map((l) => l.stepId))].join(", ");
  return `${ds.length} bình luận CÓ THỂ ĐÃ ĐĂNG nhưng máy không xác minh được (bước ${buoc}) — KHÔNG đăng lại (tránh trùng), đã ghi sổ nên các vòng sau bỏ qua bài đó. Hãy mở bài kiểm tra bằng mắt.`;
}
